export const useGlobalFunctions = () => {
    const checkTokenValidity = (data) => {
        if (data !== null && typeof data.token !== "undefined") {
            if (data.token === false) {
                localStorage.removeItem(
                    process.env.MIX_USER_SESSION_VARIABLE_NAME
                );
                this.$notify({
                    group: "notification",
                    type: "warn",
                    title: "Token expired",
                    text: "Your token is expired, please sign in again",
                });
                this.$router.push("/auth/login");
            }
        }
    };

    const formatDatetimeToTimeHistory = (
        unformattedDatetime,
        useAgo = false
    ) => {
        var timeHistory = "just now";
        if (unformattedDatetime == null) {
            return timeHistory;
        }
        var datetime = new Date(unformattedDatetime);
        var seconds = Math.floor((new Date() - datetime) / 1000);
        var interval = seconds;
        if (seconds < 60) {
            return timeHistory;
        }

        interval = Math.floor(seconds / 60);
        if (interval >= 1) {
            timeHistory = interval + " minutes";
        }

        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
            timeHistory = interval + " hours";
        }

        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
            timeHistory = interval + " days";
        }

        interval = Math.floor(seconds / 604800);
        if (interval >= 1) {
            timeHistory = interval + " weeks";
        }

        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            timeHistory = interval + " months";
        }

        interval = Math.floor(seconds / 31536000);
        if (interval >= 1) {
            timeHistory = interval + " years";
        }
        if (useAgo) {
            timeHistory += " ago";
        }
        return timeHistory;
    };

    const globalFunction_formatDate = (date) => {
        var months = this.Months;
        var formattedDate = new Date(date);
        return (
            months[formattedDate.getMonth()].name +
            " " +
            formattedDate.getDate() +
            ", " +
            formattedDate.getFullYear().toString()
        );
    };

    const globalFunction_formatDatetime = (date) => {
        var months = this.Months;
        var formattedDate = new Date(date);
        return (
            (months[formattedDate.getMonth()]
                ? months[formattedDate.getMonth()].name
                : "") +
            " " +
            formattedDate.getDate() +
            ", " +
            formattedDate.getFullYear() +
            " " +
            formattedDate.getHours() +
            ":" +
            formattedDate.getMinutes()
        );
    };

    const globalFunction_formatNumberToCurrency = (
        amount,
        currency = "$",
        allowNegative = true
    ) => {
        let amountWithoutNegative = amount;
        if (amount < 0) {
            amountWithoutNegative *= -1;
            if (allowNegative) {
                currency = "- " + currency;
            }
        }
        return (
            currency +
            "" +
            new Intl.NumberFormat("en-us", {}).format(amountWithoutNegative)
        );
    };

    const globalFunction_handleAxiosError = (error, notify = false) => {
        if (typeof error.response === "undefined") {
            console.error(error);
        } else {
            this.checkTokenValidity(error.response.data.data);
            if (notify) {
                this.$notify({
                    group: "notification",
                    type: "error",
                    title: "Failed",
                    text: error.response.data.message,
                });
            }
        }
    };

    const globalFunction_getRoleString = (role) => {
        const roles = [
            { value: "admin", text: "Admin" },
            { value: "user", text: "User" },
        ];
        try {
            let roleValue = roles.filter((element) => element.value === role);
            return roleValue[0].text;
        } catch (e) {
            let roleStrArr = role.split("_");
            for (let i = 0; i < roleStrArr.length; i++) {
                roleStrArr[i] =
                    roleStrArr[i].charAt(0).toUpperCase() +
                    roleStrArr[i].slice(1);
            }
            return roleStrArr.join(" ");
        }
    };

    const globalFunction_formatQuantityAndQtyAssmbld = (qty, qtyAssmbld) => {
        let qtyText = "";
        let text = "";
        let qtyAssmbldText = "";
        if (qty) {
            qty = qty.toString().toUpperCase();
            if (qty.includes("CONSULT ASSMBLD")) qtyText = "CONSULT ASSMBLD";
            else if (qty.includes("CONSULT")) qtyText = "CONSULT";
            const qtyNumber = parseInt(qty.replace(/\D/g, ""));
            if (qtyNumber >= 1000) qtyText = "1000+";
            else if (qtyNumber >= 750) qtyText = "750+";
            else if (qtyNumber >= 500) qtyText = "500+";
            else if (qtyNumber >= 450) qtyText = "450+";
            else if (qtyNumber >= 400) qtyText = "400+";
            else if (qtyNumber >= 350) qtyText = "350+";
            else if (qtyNumber >= 300) qtyText = "300+";
            else if (qtyNumber >= 250) qtyText = "250+";
            else if (qtyNumber >= 200) qtyText = "200+";
            else if (qtyNumber >= 150) qtyText = "150+";
            else if (qtyNumber >= 100) qtyText = "100+";
            else if (qtyNumber >= 75) qtyText = "75+";
            else if (qtyNumber >= 50) qtyText = "50+";
            else if (qtyNumber >= 25) qtyText = "25+";
            else if (qtyNumber >= 20) qtyText = "20+";
            else qtyText = "CONSULT";
            if (qty.includes("ASSMBLD")) qtyText += " REQ. ASMBLY";
        }

        if (qtyAssmbld) {
            qtyAssmbld = qtyAssmbld.toString().toUpperCase();
            if (qtyAssmbld.includes("CONSULT ASSMBLD"))
                qtyAssmbldText = "CONSULT ASSMBLD";
            else if (qtyAssmbld.includes("CONSULT")) qtyAssmbldText = "CONSULT";
            const qtyNumber = parseInt(qtyAssmbld.replace(/\D/g, ""));
            if (qtyNumber >= 1000) qtyAssmbldText = "1000+";
            else if (qtyNumber >= 750) qtyAssmbldText = "750+";
            else if (qtyNumber >= 500) qtyAssmbldText = "500+";
            else if (qtyNumber >= 450) qtyAssmbldText = "450+";
            else if (qtyNumber >= 400) qtyAssmbldText = "400+";
            else if (qtyNumber >= 350) qtyAssmbldText = "350+";
            else if (qtyNumber >= 300) qtyAssmbldText = "300+";
            else if (qtyNumber >= 250) qtyAssmbldText = "250+";
            else if (qtyNumber >= 200) qtyAssmbldText = "200+";
            else if (qtyNumber >= 150) qtyAssmbldText = "150+";
            else if (qtyNumber >= 100) qtyAssmbldText = "100+";
            else if (qtyNumber >= 75) qtyAssmbldText = "75+";
            else if (qtyNumber >= 50) qtyAssmbldText = "50+";
            else if (qtyNumber >= 25) qtyAssmbldText = "25+";
            else if (qtyNumber >= 20) qtyAssmbldText = "20+";
            else qtyAssmbldText = "CONSULT";
            if (qtyAssmbld.includes("ASSMBLD"))
                qtyAssmbldText += " REQ. ASMBLY";
        }
        if (qtyText.includes("CONSULT") && qtyAssmbldText.includes("CONSULT")) {
            text = "CONSULT";
        } else {
            text = qtyText ? qtyText : "";
            text +=
                text && qtyAssmbldText
                    ? " & " + qtyAssmbldText
                    : qtyAssmbldText;
        }
        return text;
    };

    return {
        checkTokenValidity,
        formatDatetimeToTimeHistory,
        globalFunction_formatDate,
        globalFunction_formatDatetime,
        globalFunction_formatNumberToCurrency,
        globalFunction_handleAxiosError,
        globalFunction_getRoleString,
        globalFunction_formatQuantityAndQtyAssmbld,
    };
};
